import { AccessGrant, Mutation } from 'graphql/generated/graphqlTypes';
import { generateMockAccessGrant } from 'mocks/graphqlMocks/accessGrant';

export function mockedUnassignToAccessGrantsData(
  unassignFromAccessGrants: AccessGrant[]
): Pick<Mutation, 'unassignFromAccessGrants'> {
  return {
    unassignFromAccessGrants
  };
}

export const mockedUnassignToAccessGrantsDataForMutation = mockedUnassignToAccessGrantsData([
  generateMockAccessGrant({ id: 'mockedAccessGrantId0' })
]);

export const mockedUnassignToAccessGrantsDataForMutation1 = mockedUnassignToAccessGrantsData([
  generateMockAccessGrant({ id: 'mockedAccessGrantId0' })
]);

export const mockedUnassignToAccessGrantsDataForMutation2 = mockedUnassignToAccessGrantsData([
  generateMockAccessGrant({ id: 'mockedAccessGrantId0' }),
  generateMockAccessGrant({ id: 'mockedAccessGrantId1' }),
  generateMockAccessGrant({ id: 'mockedAccessGrantId2' })
]);

export const mockedUnassignToAccessGrantsDataForMutationDoor1 = mockedUnassignToAccessGrantsData([
  generateMockAccessGrant({ id: 'mockedAccessGrantId1', doors: [] })
]);

export const mockedUnassignToAccessGrantsDataForMutationTestGroup1 = (accessGrantId: string) =>
  mockedUnassignToAccessGrantsData([generateMockAccessGrant({ id: accessGrantId, locations: [] })]);

export const mockedUnassignToAccessGrantsDataForCoContractorsDoor = mockedUnassignToAccessGrantsData([
  generateMockAccessGrant({ id: 'mockedAccessGrantIdCo-contractors', doors: [] })
]);

export const mockedUnassignToAccessGrantsDataForCoContractorsLocation = mockedUnassignToAccessGrantsData([
  generateMockAccessGrant({ id: 'mockedAccessGrantIdCo-contractors', locations: [] })
]);
